import React, { useRef } from 'react'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import type { ListItemProps } from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Image from 'next/image'
import Avatar from '@material-ui/core/Avatar'
import Drawer from '@material-ui/core/Drawer'
import { ReactComponent as ExitIcon } from '../../../assets/icons/exit.svg'

import Button from '@material-ui/core/Button'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Skeleton from '@material-ui/lab/Skeleton'
import KeyboardArrowTopIcon from '@material-ui/icons/KeyboardArrowUp'
// import MenuIcon from '@material-ui/icons/Menu'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { useUserMenuStyles } from './user-menu.styles'
import { NotificationIcon } from '../../notifications'
import { authUrls } from '../../../config'
import {
  TranslationDictionary,
  useDisclosure,
  useLocale,
  useTranslation
} from '../../../utils'
import { useQueryUser } from '../user.query'
import { useMutationLogout } from '../user.mutation'
import {
  //  getServiceURL,
  SERVICES_URL
} from '../../menu-service-button'
import { DrawerUserMenu, UserPopperMenu } from '..'
import { Link } from '@material-ui/core'

export type UserMenuItemProps = {
  title: string
  icon?: JSX.Element
  link?: string
  props?: ListItemProps
  isBreak?: boolean
  submenu?: UserMenuItemProps[]
  secondaryContent?: React.ReactNode
}

type UserMenuProps = {
  userMenu?: React.ReactNode
  onLogoutSuccess?: () => void
  userDidSignOut?: boolean
  redirectTo?: string
  translate?: TranslationDictionary['data']
  locale: string
}

export const getAuthSignInUrl = (locale: string, redirectUrl?: string) =>
  redirectUrl
    ? `${authUrls(locale).signIn}?redirectUrl=${redirectUrl}`
    : authUrls(locale).signIn

export const UserMenu: React.FC<UserMenuProps> = (props) => {
  const classes = useUserMenuStyles()
  const buttonRef = useRef<Element>()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(1340))
  const { data: translate } = useTranslation()
  const { isOpen, onClose, onToggle } = useDisclosure()
  const { isOpen: isOpenShopMenu, onClose: onShopMenuClose } = useDisclosure()
  const locale = useLocale()
  const { data: user, isLoading } = useQueryUser({
    notifyOnChangeProps: ['data'],
    staleTime: 1000 * 60
  })
  const url = SERVICES_URL
  const router = useRouter()
  // const urlLang = router.basePath.includes('ru')

  const mutation = useMutationLogout({
    onSuccess: () => {
      props.onLogoutSuccess?.()
      router.push('/')
    }
  })

  const authHref = getAuthSignInUrl(
    locale,
    router.pathname.includes('subscriptions')
      ? locale === 'ru'
        ? `${url.main}/ru${'/profile/purchases?type=specialist'}`
        : url.main + '/profile/purchases?type=specialist'
      : locale === 'ru'
      ? `${url.blog}/ru` + router.asPath
      : url.blog + router.asPath
  )

  const handleLogout = () => {
    mutation.mutate()
  }

  if (isLoading) {
    return (
      <Skeleton variant="circle" width={32} height={32}>
        <Avatar className={classes.avatar} />
      </Skeleton>
    )
  }

  if (!user || props.userDidSignOut)
    return (
      <>
        <Button
          href={
            locale === 'ru'
              ? `${url.job}/ru${'/subscriptions'}`
              : url.job + '/subscriptions'
          }
          size="small"
          className={classes.linkSubs}
        >
          {translate?.menu.subscriptions ?? 'Подписки'}
        </Button>
        <div className={classes.linkDivider}></div>
        <Button
          variant="contained"
          color="secondary"
          className={classes.buttonAuth}
          size="small"
          href={authHref}
        >
          {translate?.menu.login ?? 'Вход'}
        </Button>
      </>
    )

  return (
    <>
      {isDesktop && (
        <NotificationIcon
          notificationUrl={
            locale === 'ru'
              ? `${url.main}/ru/notifications`
              : url.main + '/notifications'
          }
          translate={props.translate}
          locale={props.locale}
        />
      )}
      <div
        onClick={onToggle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'enter' && onToggle()}
        className={classes.menuWrapper}
      >
        <IconButton color="inherit" innerRef={buttonRef} size="small">
          <Avatar className={classes.avatar} src={user.avatarUrl}>
            {user?.name?.slice(0, 1)}
          </Avatar>
        </IconButton>
        {isDesktop && (
          <div
            className={clsx(classes.iconBtnText, {
              [classes.iconBtnTextActive]: isOpen
            })}
          >
            <span>{translate?.account ?? 'Мой профиль'}</span>
            {isOpen ? (
              <KeyboardArrowTopIcon style={{ marginTop: 2 }} />
            ) : (
              <KeyboardArrowDownIcon style={{ marginTop: 2 }} />
            )}
          </div>
        )}
      </div>
      {/*<IconButton*/}
      {/*  onClick={onToggleShopMenu}*/}
      {/*  color="inherit"*/}
      {/*  innerRef={buttonRef}*/}
      {/*  size="small"*/}
      {/*>*/}
      {/*  {!isTablet && <MenuIcon />}*/}
      {/*</IconButton>*/}
      {isDesktop ? (
        <UserPopperMenu
          isOpen={isOpen}
          onClose={onClose}
          translate={translate}
          locale={props.locale}
        />
      ) : (
        <>
          <DrawerUserMenu
            isOpen={isOpen}
            onClose={onClose}
            translate={translate}
            locale={props.locale}
          />
          <Drawer
            open={isOpenShopMenu}
            onClose={onShopMenuClose}
            className={classes.drawer}
          >
            <div className={classes.headerLang}>
              <Link
                href={locale === 'ru' ? `${url.main}/ru/` : url.main}
                className={classes.logoLink}
              >
                <Image
                  width="75"
                  height="22.06"
                  alt=""
                  src="/blog/assets/logo-header.svg"
                  layout="fixed"
                />
              </Link>
              {/* <div className={classes.lang}>
                <Link href={getServiceURL('ru').blog + router.asPath}>
                  <Button
                    disabled={props.locale === 'ru'}
                    size="small"
                    className={classes.btnRu}
                  >
                    Ru
                  </Button>
                </Link>
                <div className={classes.linkDivider} />
                <Link href={getServiceURL('en').blog + router.asPath}>
                  <Button
                    disabled={props.locale === 'en'}
                    size="small"
                    className={classes.btnEng}
                  >
                    En
                  </Button>
                </Link>
              </div> */}
            </div>
            <List className={classes.menu}>
              {props.userMenu}
              <ListItem button onClick={handleLogout}>
                <ListItemIcon className={classes.exitIcon}>
                  <ExitIcon />
                </ListItemIcon>
                <ListItemText className={classes.exit}>
                  {translate?.menu.logout ?? 'Выход'}
                </ListItemText>
              </ListItem>
            </List>
          </Drawer>
        </>
      )}
    </>
  )
}
